import {Injectable} from "@angular/core";
import {BaseApiService} from "../services/base-api-service";
import {Observable} from "rxjs";
import {ApiType} from "../enums/api-type";
import {RequestType} from "../enums/RequestType";

@Injectable({providedIn: 'root'})
export class EmailApi {

  constructor(
    private baseApiService: BaseApiService
  ) {
  }

  verifyEmail(token: string) {
    console.log("Confirming email with token " + token)
    return this.baseApiService.call<{}, void>({
      apiType: ApiType.verifyEmail,
      requestType: RequestType.POST,
      pathVariables: [token]
    })
  }

  resendVerificationEmail(email: string): Observable<void> {
    return this.baseApiService.call<{}, void>({
      apiType: ApiType.resendEmailVerification,
      requestType: RequestType.POST,
      body: {
        email: email
      }
    })
  }

}
